import { gateway } from "../../../gateway";

export const updatePayLaterEnabled = async (payLaterEnabled: boolean): Promise<void> => {
  try {
    await gateway.patch("/paypal/e-commerce/account", { payLaterEnabled });
  } catch (error: any) {
    const errorMessage =
      error?.response?.data?.message || error?.message || "Failed to update Pay Later setting";
    throw new Error(errorMessage);
  }
};
